import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3154ROLES } from '../../../U3154';
import { u3154IsSystemPaymentTypeCode, type U3154PaymentTypeFormRow } from '../../../U3154Service';

export type U3154PaymentTypeFormToolbarHandlers = U2000FormStateHandlersReturn<U3154PaymentTypeFormRow> & {
  addNewPaymentType: () => void;
  modifyPaymentType: () => void;
  deletePaymentType: () => void | Promise<void>;
};

interface U3154PaymentTypeFormToolBarProps {
  formStateHandlers: U3154PaymentTypeFormToolbarHandlers;
}

export const U3154PaymentTypeFormToolBar: React.FC<U3154PaymentTypeFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();
  const data = formStateHandlers.getData();
  const deleteDisabled =
    formState === U2000FormStateEnumState.EDIT || u3154IsSystemPaymentTypeCode(data?.code);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3154ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewPaymentType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3154ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyPaymentType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3154ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deletePaymentType();
      },
      disabled: deleteDisabled,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
